import { getState, track } from "js/analytics/util";
import getLogger, { LogGroup } from "js/core/logger";

const logger = getLogger(LogGroup.ANALYTICS);

export enum AmplitudeCategories {
    Auth = "Auth",
    Image = "Image",
    ModifyWorkspacePlan = "ModifyWorkspacePlan",
    ModifyWorkspaceUsers = "ModifyWorkspaceUsers",
    PaymentMethod = "PaymentMethod",
    PresentationOutline = "PresentationOutline",
    Presentation = "Presentation",
    Slide = "Slide",
    SignupFlow = "SignupFlow",
    SignupFlowMay2026 = "SignupFlowMay2026",
    Dunning = "Dunning",
    PlanPreview = "PlanPreview",
}

interface TrackerProps {
    workspace_id?: string;
    [key: string]: any;
}

export function trackEvent<P extends TrackerProps = TrackerProps>(category: AmplitudeCategories, action: string, props: P, { audit = false, gtag = null } = {}) {
    try {
        const state = getState();

        if (!state.workspace_id && !props.workspace_id) {
            throw new Error(`Missing required attribute 'workspace_id'`);
        }
        track({
            category,
            action,
            label: "none",
            value: 0,
            props,
            audit,
            ...(gtag ? { gtag } : {})
        });
    } catch (err) {
        logger.error(err, `Amplitude event ${category}:${action} failed`);
    }
}

export function createTrackerForCategory(category: AmplitudeCategories) {
    return function track<P extends TrackerProps = TrackerProps>(action: string, props: P, { audit = false, gtag = null } = {}) {
        return trackEvent(category, action, props, { audit, gtag });
    };
}
